import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import language from '../utils/language';

const i18nInstance = i18n
  .use(Backend)
  .use(initReactI18next);

const options = {
  lng: language.getLanguage(),
  load: 'currentOnly',
  fallbackLng: 'ru-RU',

  debug: true,

  react: {
    wait: true,
    useSuspense: false,
  },

  backend: {
    loadPath: '/rating/locales/translation-{{lng}}.json',
    crossDomain: true,
  },

  interpolation: {
    escapeValue: false,
  },
};

export default {
  init: () => i18nInstance.init(options),
  t: (value, count) => i18nInstance.t(value, { count }),
  exists: value => i18nInstance.exists(value),
};
